<div [formGroup]="deviceForm">
    <mat-card appearance="outlined" class="flat mt-10">
        <div class="row">
            <div class="col-xs-12">
                <div class="row">
                    <div class="header-space">
                        <div
                            style="margin-bottom: 10px"
                            data-tx-key="label.gb.device_data"
                        >
                            <h3 [id]="identifierService.labelId('deviceTransmitInfo', 'deviceData')" class="merlin-header">
                                {{ labels['label.gb.device_data'] }}
                            </h3>
                        </div>
                    </div>
                    <div class="pl-15">
                        @if (
                            functionMode !== 'enroll' &&
                            !patRes?.patientDevices?.[0]?.isICMDevice &&
                            !isAveir &&
                            !isICMCategory
                        ) {
                            <div
                                (click)="openViewLeadsDialog()"
                                [ngStyle]="{
                                    color: 'black',
                                    'pointer-events': 'auto',
                                    cursor: 'pointer',
                                }"
                            >
                                <p
                                    [id]="identifierService.buttonId('deviceTransmitInfo', 'viewLeads')"
                                    class="sectionTitle popupLink"
                                    data-tx-key="label.gb.view_leads"
                                >
                                    {{ labels['label.gb.view_leads'] }}
                                </p>
                            </div>
                        }
                    </div>
                </div>
                @if (displayEditUI()) {
                    <div class="row">
                        <div class="col-xs-2 col-md-2 col-lg-2 merlin-row-styl">
                            <merlin-textbox
                                maxLength="9"
                                [groupName]="deviceForm"
                                label="{{
                                    labels['label.gb.serial_number']
                                }}"
                                placeHolder="{{
                                    labels['label.gb.serial_number']
                                }}"
                                [required]="true"
                                controlName="serialNum"
                                [id]="
                                    identifierService.dropdownId(
                                        'device-transmit-information',
                                        'serialNum'
                                    )
                                "
                                (blured)="serialNumBlur($event)"
                                data-tx-key="label.gb.serial_number"
                            ></merlin-textbox>
                        </div>
                        <div class="col-xs-2 col-md-2 col-lg-2">
                            <mat-form-field
                                class="merlin-select merlin-row-styl full-width"
                                appearance="outline"
                            >
                                <mat-label [id]="identifierService.labelId('devTransmitInfo','devName')" data-tx-key="label.gb.dev_name"
                                    >{{ labels['label.gb.dev_name'] }}
                                </mat-label>
                                <mat-select
                                    disableOptionCentering
                                    formControlName="productId"
                                    [required]="true"
                                    [id]="
                                        identifierService.dropdownId(
                                            'device-transmit-information',
                                            'productId'
                                        )
                                    "
                                    (selectionChange)="deviceOnChange($event)"
                                    data-tx-key="label.gb.dev_name"
                                >
                                    <mat-option>
                                        <ngx-mat-select-search
                                            [formControl]="deviceSearchControl"
                                            [placeholderLabel]="labels['label.gb.search']"
                                            noEntriesFoundLabel="Not found"
                                        ></ngx-mat-select-search>
                                    </mat-option>
                                    @for (
                                        option of filteredDeviceList | async;
                                        track option
                                    ) {
                                        <mat-option [id]="identifierService.listitemId('device-transmit-information', 'deviceOption_' + option?.value)" [value]="option.value" [disabled]="option.disabled">
                                            {{ option?.label }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-xs-2 col-md-2 col-lg-2">
                            <mat-form-field
                                class="merlin-select merlin-row-styl full-width"
                                appearance="outline"
                            >
                                <mat-label [id]="identifierService.labelId('devTransmitInfo','implantDateLabel')" data-tx-key="label.gb.implant_date"
                                    >{{ labels['label.gb.implant_date'] }}
                                </mat-label>
                                <input
                                    matInput
                                    [maxLength]="10"
                                    formControlName="implantDate"
                                    (ngModelChange)="dateValidator($event)"
                                    [required]="
                                        isICMCategory &&
                                        isRequiredImplantDateForUS
                                    "
                                    [placeholder]="translatePlaceHolder()"
                                    [id]="
                                        identifierService.dropdownId(
                                            'device-transmit-information',
                                            'implantDate'
                                        )
                                    "
                                />
                            </mat-form-field>
                        </div>
                        @if(( showDrDeviceCheckbox || isICMCategory || isLPCategory) && deviceForm?.get('isImplantPhysicianEditable')?.value) {
                            <div class="col-xs-3 col-md-3 col-lg-3">
                                <mat-form-field class="merlin-select merlin-row-styl full-width" appearance="outline">
                                    <mat-label [id]="identifierService.labelId('devTransmitInfo','docPerformImplant')" data-tx-key="label.gb.doc_perform_implant">{{
                                        labels['label.gb.doc_perform_implant']
                                    }}
                                    </mat-label>
                                    <mat-select disableOptionCentering formControlName="implantPhyId" [required]="
                                            isRequiredImplantDateForUS && isICMCategory
                                            " [id]="
                                            identifierService.dropdownId(
                                                'device-transmit-information',
                                                'performImplant'
                                            )
                                        " (selectionChange)="implantOnChange($event, false)" data-tx-key="label.gb.doc_perform_implant">
                                        <mat-option>
                                            <ngx-mat-select-search [formControl]="implantPhySearchControl" [placeholderLabel]="labels['label.gb.search']"
                                                noEntriesFoundLabel="Not found"></ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option [value]="null" [id]="identifierService.listitemId('device-transmit-information', 'phyOption_empty')"> &nbsp;</mat-option>
                                        @for (
                                        impId of filterImplantPhyIdsOption
                                                | async;
                                            track impId
                                        ) {
                                            <mat-option [id]="identifierService.listitemId('device-transmit-information', 'phyOption_' + impId?.lastName)" [value]="impId.acctId">
                                                @if (impId?.mainLocation) {
                                                    <span [id]="identifierService.labelId('deviceTransmitInfo', 'primaryPhyLocation')"
                                                        >{{
                                                            impId?.mainLocation
                                                        }}:</span
                                                    >
                                                }
                                                {{ impId?.lastName }},
                                                {{ impId?.firstName }}
                                                {{ impId?.middleName }}
                                                {{ impId?.credentialsCd }}
                                            </mat-option>
                                        }
                                        @if(![null,''].includes(deviceForm?.get('implantPhyId')?.value)){
                                            <mat-option
                                                [value]="deviceForm?.get('implantPhyId')?.value"
                                                style="display:none"
                                                >
                                                {{ getImplantPhysicianTriggerText(false) }}
                                            </mat-option>
                                        }   
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        }
                        <!-- Get transferred patient implanting physician details -->
                        @if (
                            (isICMCategory || isLPCategory) && !deviceForm?.get('isImplantPhysicianEditable')?.value
                        ) {
                            <div class="col-xs-3 col-md-3 col-lg-3">
                                <mat-form-field
                                    class="merlin-select merlin-row-styli full-width"
                                    appearance="outline"
                                >
                                    <mat-label [id]="identifierService.labelId('devTransmitInfo','transPatientImplantPhyIdData')">{{
                                        labels['label.gb.doc_perform_implant']
                                    }}</mat-label>
                                    <input [id]="identifierService.textboxId('device-transmit-information', 'transPatientImplantPhy')" type="text" matInput formControlName="transPatientImplantPhyIdData" readonly
                                    />
                                </mat-form-field>
                            </div>
                        }
                        @if (showRemoveButtons && displayEditUI()) {
                            <div class="col-xs-2 col-md-2 col-lg-2 ver-center">
                                <button
                                    [id]="identifierService.buttonId('deviceTransmitInfo', 'removePrimary')"
                                    mat-raised-button
                                    color="primary"
                                    (click)="onRemovePrimaryDevice()"
                                    type="button"
                                    class="remove-device-btn"
                                    [disabled]="primaryDeviceRemoved || drDeviceRemoved"
                                    data-tx-key="label.gb.remove"
                                >
                                    {{ 'label.gb.remove' | translate }}
                                </button>
                            </div>
                        }
                        @if (showTrueAAIInfoFlag && displayEditUI()) {
                            <div class="col-xs-2 col-md-2 col-lg-2">
                                <mat-form-field
                                    class="merlin-select merlin-row-styl full-width"
                                    appearance="outline"
                                >
                                    <mat-label [id]="identifierService.labelId('devTransmitInfo','requiredField')"
                                        >*
                                        {{
                                            labels['label.gb.lead_chamber']
                                        }}
                                    </mat-label>
                                    <mat-select
                                        disableOptionCentering
                                        label="{{
                                            labels['label.gb.lead_chamber']
                                        }}"
                                        formControlName="leadChmbSettingCd"
                                        [id]="
                                            identifierService.dropdownId(
                                                'device-transmit-information',
                                                'leadChamber'
                                            )
                                        "
                                    >
                                        <mat-option></mat-option>
                                        @for (
                                            imp of dropDownsList.leadChmbCodes;
                                            track imp
                                        ) {
                                            <mat-option [id]="identifierService.listitemId('device-transmit-information', 'leadChmbOption_' + imp?.codeId)" [value]="imp.codeId">{{
                                                labels[
                                                    'data.Code.' +
                                                        imp.qualifier +
                                                        '.Code_Desc.' +
                                                        imp.code
                                                ]
                                            }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        }
                    </div>
                }
                @if (showDrDeviceCheckbox && displayEditUI()) {
                    <div class="row mt-5">
                        <div class="col-xs-2 col-md-2 col-lg-2 ver-center">
                            <mat-checkbox
                                formControlName="drDevice"
                                [id]="
                                    identifierService.dropdownId(
                                        'device-transmit-information',
                                        'drDevice'
                                    )
                                "
                                >{{ labels['label.gb.DR_chk'] }}</mat-checkbox
                            >
                        </div>
                    </div>
                }
                @if (
                    showDrDeviceCheckbox &&
                    (deviceForm?.get('drDevice')?.value || showRemoveButtons) &&
                    displayEditUI()
                ) {
                    <div class="row mt-3">
                        <!-- DR Serial Number -->
                        <div class="col-xs-2 col-md-2 col-lg-2 merlin-row-styl">
                            <merlin-textbox
                                maxLength="9"
                                [groupName]="deviceForm"
                                label="{{
                                    labels['label.gb.serial_number']
                                }}"
                                placeHolder="{{
                                    labels['label.gb.serial_number']
                                }}"
                                [required]="true"
                                controlName="drSerialNum"
                                [id]="
                                    identifierService.dropdownId(
                                        'device-transmit-information',
                                        'drSerialNum'
                                    )
                                "
                                data-tx-key="label.gb.serial_number"
                            ></merlin-textbox>
                        </div>
                        <!-- DR Device Name -->
                        <div class="col-xs-2 col-md-2 col-lg-2">
                            <mat-form-field
                                class="merlin-select merlin-row-styl full-width"
                                appearance="outline"
                            >
                                <mat-label [id]="identifierService.labelId('devTransmitInfo','drDeviceName')" data-tx-key="label.gb.dev_name">{{
                                    labels['label.gb.dev_name']
                                }}</mat-label>
                                <mat-select
                                    disableOptionCentering
                                    formControlName="drProductId"
                                    [required]="true"
                                    (selectionChange)="drDeviceOnChange($event)"
                                >
                                    <mat-option>
                                        <ngx-mat-select-search
                                            [formControl]="drDeviceSearchControl"
                                            [placeholderLabel]="labels['label.gb.search']"
                                            noEntriesFoundLabel="Not found"
                                        ></ngx-mat-select-search>
                                    </mat-option>
                                    @for (
                                        option of drFilteredOptions | async;
                                        track option
                                    ) {
                                        <mat-option [id]="identifierService.listitemId('device-transmit-information', 'deviceOption_' + option?.value)" [value]="option.value" [disabled]="option.disabled">{{ option?.label }}</mat-option
                                        >
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <!-- DR Implant Date -->
                        <div class="col-xs-2 col-md-2 col-lg-2">
                            <mat-form-field
                                class="merlin-select merlin-row-styl full-width"
                                appearance="outline"
                            >
                                <mat-label [id]="identifierService.labelId('devTransmitInfo','drImplantDate')"
                                    data-tx-key="label.gb.implant_date"
                                    >{{
                                        labels['label.gb.implant_date']
                                    }}</mat-label
                                >
                                <input [id]="identifierService.textboxId('device-transmit-information', 'drImplantDate')" matInput [maxLength]="10" formControlName="drImplantDate"
                                    (ngModelChange)="dateValidator($event)"
                                    [placeholder]="translatePlaceHolder()"
                                    aria-label="Implant Date"
                                />
                            </mat-form-field>
                        </div>
                        <!-- DR Implant Physician -->
                         @if(deviceForm?.get('isImplantPhysicianEditableDR')?.value) {
                            <div class="col-xs-3 col-md-3 col-lg-3">
                                <mat-form-field class="merlin-select merlin-row-styl full-width" appearance="outline">
                                    <mat-label [id]="identifierService.labelId('devTransmitInfo','drImplantPhyIdName')" data-tx-key="label.gb.doc_perform_implant">{{
                                        labels['label.gb.doc_perform_implant']
                                    }}
                                    </mat-label>
                                    <mat-select disableOptionCentering formControlName="drImplantPhyId" [id]="
                                            identifierService.dropdownId(
                                                'device-transmit-information',
                                                'drImplantPhyIdName'
                                            )
                                        " (selectionChange)="implantOnChange($event, true)" data-tx-key="label.gb.doc_perform_implant">
                                        <mat-option>
                                            <ngx-mat-select-search [formControl]="implantPhySearchControlDR" [placeholderLabel]="labels['label.gb.search']"
                                                noEntriesFoundLabel="Not found"></ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option [value]="null" [id]="identifierService.listitemId('device-transmit-information', 'phyOptionDR_empty')"> &nbsp;</mat-option>
                                        @for (
                                        impId of filterImplantPhyIdsOptionDr
                                                | async;
                                            track impId
                                        ) {
                                            <mat-option [id]="identifierService.listitemId('device-transmit-information', 'phyOption_' + impId?.lastName)" [value]="impId.acctId">
                                                @if (impId?.mainLocation) {
                                                    <span [id]="identifierService.labelId('deviceTransmitInfo', 'drPhyLocation')"
                                                        >{{
                                                            impId?.mainLocation
                                                        }}:</span
                                                    >
                                                }
                                                {{ impId?.lastName }},
                                                {{ impId?.firstName }}
                                                {{ impId?.middleName }}
                                                {{ impId?.credentialsCd }}
                                            </mat-option>
                                        }
                                        @if(![null,''].includes(deviceForm?.get('drImplantPhyId')?.value)){
                                            <mat-option
                                                [value]="deviceForm?.get('drImplantPhyId')?.value"
                                                style="display:none"
                                                >
                                                {{ getImplantPhysicianTriggerText(true) }}
                                            </mat-option>
                                        }   
                                    </mat-select>
                                </mat-form-field>
                            </div>
                         } 
                         @if (!deviceForm?.get('isImplantPhysicianEditableDR')?.value) {
                             <!-- If DR Implant Physician is not editable, show it in read only mode -->
                            <div class="col-xs-3 col-md-3 col-lg-3">
                                <mat-form-field
                                    class="merlin-select merlin-row-styli full-width"
                                    appearance="outline"
                                >
                                    <mat-label [id]="identifierService.labelId('devTransmitInfo','drTransPatientImplantPhyIdData')">{{
                                        labels['label.gb.doc_perform_implant']
                                    }}</mat-label>
                                    <input [id]="identifierService.textboxId('device-transmit-information', 'drTransPatientImplantPhy')" type="text" matInput formControlName="drTransPatientImplantPhyIdData" readonly
                                    />
                                </mat-form-field>
                            </div>
                         }
                        @if (showRemoveButtons && displayEditUI()) {
                            <div class="col-xs-2 col-md-2 col-lg-2 ver-center">
                                <button
                                    [id]="identifierService.buttonId('deviceTransmitInfo', 'removeDr')"
                                    mat-raised-button
                                    color="primary"
                                    (click)="onRemoveDrDevice()"
                                    type="button"
                                    class="remove-device-btn"
                                    [disabled]="primaryDeviceRemoved || drDeviceRemoved"
                                    data-tx-key="label.gb.remove"
                                >
                                    {{ 'label.gb.remove' | translate }}
                                </button>
                            </div>
                        }
                    </div>

                    @if (deviceForm?.get('drDevice')?.value) {
                        <div class="row">
                            <div
                                class="col-xs-12 ar-vr-device-hint"
                                data-tx-key="label.gb.select_ar_vr_device"
                            >
                                <span [id]="identifierService.labelId('deviceTransmitInfo', 'deviceText')" class="device-label-prefix-new"
                                    >{{ labels['label.gb.device_label'] }}: &nbsp;</span
                                >
                                <span [id]="identifierService.labelId('deviceTransmitInformation', 'aveirPair')" class="device-label-text">{{ aveirPairLabel }}</span>
                            </div>
                        </div>
                    }
                }
            </div>
        </div>
    </mat-card>
    @if (!activatorClinicFlg) {
        @if (
            (!showPhysicianOpt && !isNGQCategory && !isICMCategory && !isLPCategory) ||
            transmitterVisibleOnEmpty
        ) {
            <mat-card
                appearance="outlined"
                class="flat mt-10"
                style="margin-bottom: 10px"
            >
                <div class="row">
                    <div class="col-xs-3 col-md-3 col-lg-3">
                        <div
                            [id]="identifierService.labelId('deviceTransmitInfo', 'transmitterHeader')"
                            class="merlin-header"
                            style="margin-bottom: 10px"
                            data-tx-key="label.gb.transmitter"
                        >
                            {{ labels['label.gb.transmitter'] }}
                        </div>
                        @if (
                            (!showPhysicianOpt && !isNGQCategory) ||
                            transmitterVisibleOnEmpty
                        ) {
                            <mat-radio-group
                                formControlName="transmitter"
                                class="radio-group align-fields row"
                                [disabled]="disableTransmitterBox()"
                                [id]="
                                    identifierService.dropdownId(
                                        'device-transmit-information',
                                        'transmitter'
                                    )
                                "
                            >
                                <div class="flex flex-row gap-10">
                                    <mat-radio-button
                                        [disabled]="
                                            patRes?.patient
                                                ?.transmitterOrderFlg &&
                                            disableTransmitterRadioBtn()
                                        "
                                        class="col-sm-1"
                                        color="primary"
                                        [value]="true"
                                        [id]="
                                            identifierService.dropdownId(
                                                'device-transmit-information',
                                                'orderTransmit'
                                            )
                                        "
                                    ></mat-radio-button>
                                    &nbsp;
                                    <span
                                        [id]="identifierService.labelId('deviceTransmitInfo', 'orderTransmit')"
                                        class="radioLabel"
                                        data-tx-key="label.gb.order_transmit"
                                        >{{
                                            labels['label.gb.order_transmit'
                                               ]
                                        }}</span
                                    >
                                </div>
                                <div class="flex flex-row gap-10">
                                    <mat-radio-button
                                        [disabled]="
                                            patRes?.patient
                                                ?.transmitterOrderFlg &&
                                            disableTransmitterRadioBtn()
                                        "
                                        class="col-sm-1 PatientHasTrans"
                                        color="primary"
                                        [value]="false"
                                        [id]="
                                            identifierService.dropdownId(
                                                'device-transmit-information',
                                                'patHasTrans'
                                            )
                                        "
                                    ></mat-radio-button>
                                    &nbsp;
                                    <span
                                        [id]="identifierService.labelId('deviceTransmitInfo', 'patHasTrans')"
                                        class="radioLabel"
                                        data-tx-key="label.gb.pat_has_trans"
                                        >{{
                                            labels['label.gb.pat_has_trans']
                                        }}
                                    </span>
                                </div>
                            </mat-radio-group>
                        }
                        <span [id]="identifierService.labelId('deviceTransmitInformation', 'orderTransmitterMsg')">{{ orderTransmitterMsg }}</span>
                    </div>
                    <div class="col-xs-3 col-md-3 col-lg-3 orderDate">
                        @if (
                            patRes?.patient?.transmitterOrderFlg &&
                            disableTransmitterRadioBtn()
                        ) {
                            <div [id]="identifierService.labelId('deviceTransmitInformation', 'OrdTrDate')">{{ OrdTrDate }}</div>
                        }
                    </div>
                    <div class="col-xs-3 col-md-3 col-lg-3 dataCollectionCheck">
                        @if (dataMiningFlg) {
                            <mat-checkbox
                                formControlName="dataMiningFlg"
                                [disabled]="disableTransmitterBox()"
                                [id]="
                                    identifierService.dropdownId(
                                        'device-transmit-information',
                                        'dataMiningConsent'
                                    )
                                "
                                data-tx-key="label.gb.record_data_collection_consent"
                                >{{
                                    labels['label.gb.record_data_collection_consent'
                                       ]
                                }}
                            </mat-checkbox>
                        }
                    </div>
                </div>
            </mat-card>
        }
    }
</div>
